import paginatedStudents from './UserGroups.students'

export const LicenseManagementUserGroupIdServices = {
  students: {
    paginated: paginatedStudents
  }
}
